import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig } from '../types';

const qualitylogsConfig: TSPConfig = {
  key: 'qualitylogseld',
  name: 'QualityLogs',
  category: TSPCategory.CUSTOM,
  helpText: 'Input the credentials you use to log into the QualityLogs portal.',
  loginComponent: (props: LoginComponentProps) => {
    return (
      <LoginCreds
        onValidityChange={props.onValidityChange}
        fields={[
          { label: 'Username', name: 'username', type: 'text', required: true },
          {
            label: 'Password',
            name: 'password',
            type: 'password',
            required: true,
          },
        ]}
      />
    );
  },
};

export default qualitylogsConfig;
